module.exports = __webpack_public_path__ + "static/media/ic_affaire.c19fad6c.svg";